<template>
  <div class="DecorationSelect-container">
    <el-select
      v-model="value"
      ref="select"
      placeholder="请选择项目，可输入关键字搜索"
      filterable
      clearable
      prefix-icon="el-icon-search"
      :filter-method="searchOrder"
      :disabled="disabled"
      :style="tcfstyle"
      @clear="clearSelect">
      <el-option :value="value" :label="changeLabel" style="height: auto;padding: 0;">
        <el-table
          :data="tableData"
          :show-header="false"
          :row-style="{cursor: 'pointer'}"
          @row-click="openDetails"
          style="width: 100%">
          <el-table-column
            label="房屋标识"
            width="180"
            show-overflow-tooltip>
            <template slot-scope="scope">
              <span style="color:#000;">{{scope.row.name}}</span>
            </template>
          </el-table-column>
          <el-table-column
            label="客户名称"
            width="160"
            show-overflow-tooltip>
            <template slot-scope="scope">
              <span style="color:#99a9bf">客户名称：</span>
              <span>{{scope.row.custname}}</span>
            </template>
          </el-table-column>
          <el-table-column
            label="联系电话"
            width="180"
            show-overflow-tooltip>
            <template slot-scope="scope">
              <span style="color:#99a9bf">联系电话：</span>
              <span>{{scope.row.tel}}</span>
            </template>
          </el-table-column>
          <el-table-column
            label="详细地址"
            min-width="200"
            show-overflow-tooltip>
            <template slot-scope="scope">
              <span style="color:#99a9bf">详细地址：</span>
              <span>{{scope.row.province}}{{scope.row.city}}{{scope.row.county}}{{scope.row.address}}</span>
            </template>
          </el-table-column>
        </el-table>
      </el-option>
      <el-pagination
        v-if="total>0"
        style="padding:10px"
        background
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-size="pageSize"
        layout="total, prev, pager, next, jumper"
        :total="total">
      </el-pagination>
    </el-select>
  </div>
</template>

<script>
import { getDelDecorationList } from '@/api/dealer'

export default {
  name: 'OrderSelect',
  props: {
    delid: {
      type: String
    },
    userid: {
      type: Number
    },
    disabled: {
      type: Boolean,
      default: false
    },
    tcfstyle: {
      type: String,
      default: 'width: 100%'
    }
  },
  data() {
    return {
      loading: false,
      tableData: [],
      currentPage: 1,
      pageSize: 5,
      total: 0,
      filterText: '',
      value: '',
      changeLabel: ''
    }
  },
  created() {
    this.getData()
  },
  methods: {
    getData() {
      this.loading = true
      const data = {
        delid: this.delid,
        userid: this.userid,
        search: this.filterText,
        page: this.currentPage,
        limit: this.pageSize
      }
      getDelDecorationList(data).then(response => {
        this.loading = false
        this.tableData = response.data
        this.total = response.total
      }).catch(() => {
        this.loading = false
      })
    },
    handleCurrentChange(val) {
      this.currentPage = val
      this.getData()
    },
    clearSelect() {
      this.filterText = ''
      this.value = ''
      this.changeLabel = ''
      this.$emit('input', this.value)
    },
    searchOrder(val) {
      this.filterText = val
      this.currentPage = 1
      this.getData()
    },
    openDetails(data) {
      this.value = data.did
      this.changeLabel = data.name + ' / ' + data.custname + ' / ' + data.tel
      this.$emit('input', this.value)
      this.$emit('setDecoration', data)
      this.$refs.select.blur()
    }
  }
}
</script>
<style lang="scss" scoped>
.DecorationSelect-container{
  .el-table::before{
    height: 0!important;
  }
  .el-pagination{
    margin-top: 20px;
  }
}
</style>
